import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X6Page, X6PageUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class EditPageStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly page: X6Page) {
    makeObservable(this);
    this.name = new StringControl('name', page.Name, validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X6PageUpdateModel = {
      LessonId: this.page.LessonId,
      Index: this.page.Index,
      Name: this.name.value
    };
    this.save = contentLoaders.x6page.update(this.page.Id, model);
  }
}
